app.controller('passwordreset', ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
  $scope.passOne = '';
  $scope.passTwo = '';
  $scope.pwChecks = [false, false, false, false];
  $scope.register = false;

  $scope.passMatch = function()
  {
    if($scope.passOne === '' || $scope.passOne === undefined)
    {
      return false;
    }
    if($scope.passOne === $scope.passTwo)
    {
      return true;
    } else {
      return false;
    }
  };

  $scope.checkPw = function () {
    $scope.pwChecks = [false, false, false, false];
    var newpw = $scope.passOne;

    $scope.pwChecks = [
      /[A-Z]/g.test(newpw),
      /[a-z]/g.test(newpw),
      newpw.length >= 8 ? true : false,
      /\d/g.test(newpw)
    ];
  };

  $scope.allowPost = function()
  {
    var allow = false;
    var checkOne = false;
    var checkTwo = false;
    var count = 0;

    angular.forEach($scope.pwChecks,function(value,key){
      if(value === true)
      {
        count++;
      }
    });
    if(count == 4)
    {
      checkOne = true;
    }
    checkTwo = $scope.passMatch();

    if(checkOne === true && checkTwo === true)
    {
      allow = true;
    } else {
      allow = false;
    }

    return allow;
  };

  $scope.registerInterest = function()
  {
    console.log($scope.email);
    $http.post('/interest/register',{email:$scope.email})
        .success(function(){
          $scope.register = true;
        });
  }

}]);
